import { invalidateSingleEntryCache } from 'api/urql/helpers/mutation';
import { get } from 'lodash';
import gql from 'graphql-tag.macro';

export const updateJobRequest = (results, args, cache, info) => {
  // for handling open/close job request
  // we only need to update the JR in place
  if (get(args, 'attributes.openRequest')) {
    cache.writeFragment(
      gql`
        fragment _ on JobRequest {
          id
          closedPreferred
          canOpenClosedPreferred
        }
      `,
      {
        id: args.id,
        closedPreferred: !get(args, 'attributes.openRequest'),
        canOpenClosedPreferred: false,
      }
    );
  } else {
    invalidateSingleEntryCache('JobRequest')(results, args, cache, info);
  }
};
